"use client";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/src/components/ui/breadcrumb";
import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export function BreadcrumbView() {
  const asPath = usePathname(); // Get the current path in Next.js
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true); // Ensure we're on the client side
  }, []);

  if (!isClient) {
    return <></>; // You can return a loader or null here while waiting for client-side rendering
  }

  // Split the current path into segments
  const pathSegments = asPath.split("/").filter(Boolean); // Remove empty segments

  // Function to create breadcrumb links dynamically based on the path segments
  const generateBreadcrumbs = () => {
    try {
      return pathSegments.map((segment, index) => {
        // Construct the full path up to this segment
        const pathToSegment = `/${pathSegments.slice(0, index + 1).join("/")}`;

        // If it's the last segment, render it as a non-clickable (active) breadcrumb
        if (index === pathSegments.length - 1) {
          return (
            <BreadcrumbItem key={index}>
              <span>{segment}</span>
            </BreadcrumbItem>
          );
        }

        // For all other segments, render a clickable breadcrumb link
        return (
          <React.Fragment key={index}>
            <BreadcrumbItem>
              <BreadcrumbLink href={pathToSegment}>{segment}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
          </React.Fragment>
        );
      });
    } catch (error: any) {
      console.log(error);
      return <></>;
    }
  };

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink href="/">Home</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />

        {/* Generate dynamic breadcrumbs based on URL */}
        {generateBreadcrumbs()}

        {/* Optional Dropdown for long navigation paths */}
        {/* <BreadcrumbItem>
                    <DropdownMenu>
                        <DropdownMenuTrigger className="flex items-center gap-1">
                            <BreadcrumbEllipsis className="h-4 w-4" />
                            <span className="sr-only">Toggle menu</span>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="start">
                            <DropdownMenuItem>Documentation</DropdownMenuItem>
                            <DropdownMenuItem>Themes</DropdownMenuItem>
                            <DropdownMenuItem>GitHub</DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </BreadcrumbItem> */}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
